var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$route.path === "/initiation/toCreate"
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showQiFeng,
                    expression: "showQiFeng"
                  }
                ],
                ref: "qifengBox",
                staticClass: "qifeng-box",
                on: {
                  drop: function($event) {
                    return _vm.dropData($event)
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "qifeng-switch",
                    on: {
                      click: function($event) {
                        _vm.showQiFeng = !_vm.showQiFeng
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.showQiFeng ? "收起" : "展开") + "\n          "
                    ),
                    _c("i", {
                      class: _vm.showQiFeng
                        ? "el-icon-d-arrow-right"
                        : "el-icon-d-arrow-left"
                    })
                  ]
                ),
                _vm._l(5, function(i) {
                  return _c("div", {
                    key: "page" + i,
                    staticClass: "qifeng-page"
                  })
                }),
                _c("p", { staticClass: "vertical-text" }, [
                  _vm._v("骑缝章区域")
                ]),
                _vm._l(_vm.qifengChapList, function(qifeng, i) {
                  return [
                    _c(
                      "div",
                      {
                        key: i,
                        staticClass: "qifeng-sign",
                        staticStyle: { position: "absolute" },
                        attrs: { id: "qifengSign" + qifeng.cindex }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              "qz-new": true,
                              draging:
                                _vm.cachetMove &&
                                _vm.currentIndex === qifeng.cindex,
                              enterprise_qz_new: qifeng.signatoryUserType
                            },
                            style: {
                              width:
                                (qifeng.signatoryUserType ? 208 : 115) + "px",
                              height:
                                (qifeng.signatoryUserType ? 230 : 79) + "px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  "!mousedown": function($event) {
                                    return _vm.handleCacheMousedown($event, {
                                      currentIndex: qifeng.cindex
                                    })
                                  }
                                }
                              },
                              [
                                _c("h1", [_vm._v(_vm._s(qifeng.signOwner))]),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "con",
                                      {
                                        enterprise_con:
                                          qifeng.signatoryUserType,
                                        padding_top: qifeng.forge
                                      }
                                    ]
                                  },
                                  [
                                    qifeng.name
                                      ? _c("p", { staticClass: "text" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("eclipse")(qifeng.name)
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                ),
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/images/move-icon.png")
                                  }
                                }),
                                _c("span", { staticClass: "time" }, [
                                  _vm._v("日期：XXXX")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b236452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b236452","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/contract-view/qifengSign.vue
// module id = xea7
// module chunks = 2 3 6 8 14 35 36 44 45 46 49